import { FormikErrors } from 'formik'
import { useTranslation } from 'react-i18next'

import { FILTER_TAGS } from '@pages/Trade/utils/constants'

interface FormValues {
  name: string
}

export const useWatchlistNameValidation = (existingNames: string[], initialName?: string) => {
  const { t } = useTranslation()

  return (values: FormValues): FormikErrors<FormValues> => {
    const result: FormikErrors<FormValues> = {}
    const trimmed = values.name.trim()

    if (!trimmed) {
      result.name = t('Validation.Required')
    } else if (trimmed.length > 20) {
      result.name = t('Validation.Max {{amount}} characters allowed', { amount: 20 })
    } else if (!/^[\p{L}\p{N}\p{M}\s_]+$/u.test(trimmed)) {
      result.name = t('Instruments.Watchlist name special characters not allowed')
    } else if (
      trimmed.toLowerCase() !== initialName?.trim().toLowerCase() &&
      FILTER_TAGS.some((tag) => tag.toLowerCase() === trimmed.toLowerCase())
    ) {
      result.name = t('Instruments.Watchlist name reserved')
    } else if (
      trimmed.toLowerCase() !== initialName?.trim().toLowerCase() &&
      existingNames.map((n) => n.toLowerCase()).includes(trimmed.toLowerCase())
    ) {
      result.name = t('Instruments.Watchlist with this name already exists')
    }

    return result
  }
}
